import { YoutubePlayer } from 'Shared/youtube-player';

YoutubePlayer.init();
